import { render, staticRenderFns } from "./StudentCasePathForm.vue?vue&type=template&id=c0bca750&scoped=true"
import script from "./StudentCasePathForm.vue?vue&type=script&lang=js"
export * from "./StudentCasePathForm.vue?vue&type=script&lang=js"
import style0 from "./StudentCasePathForm.vue?vue&type=style&index=0&id=c0bca750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bca750",
  null
  
)

export default component.exports